
import React, { useState, useEffect, useRef } from 'react';
import { FiFilter, FiRotateCw, FiPlus, FiSearch, FiChevronDown } from "react-icons/fi";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, startOfWeek, endOfWeek } from "date-fns";
import map from '../../assets/map.svg';
import { useNavigate } from 'react-router-dom';
import { getAllShipment, postCustomContainerForm, getContainerInfo, getShippingLineList, getAllDispatchReport, getAllAttendance, getAllInvoices } from '../../ApiController/ApiService';
import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import L from 'leaflet';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useTranslation } from 'react-i18next';
import { useDashboard } from '../Context/Dashboardcontext';

// Fix Leaflet default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const statusColors = {
  'In-Transit': 'bg-blue-500',
  Delivered: 'bg-green-500',
  Delayed: 'bg-red-500',
  Pending: 'bg-yellow-400',
  Completed: 'bg-green-500',
  'In-Progress': 'bg-blue-500',
  Active: 'bg-green-500',
  Optimized: 'bg-green-500',
};

const drivers = [
  { id: 1, name: 'John Doe', avatar: 'https://i.pravatar.cc/40?img=1' },
  { id: 2, name: 'Jane Smith', avatar: 'https://i.pravatar.cc/40?img=2' },
  { id: 3, name: 'Alex Johnson', avatar: 'https://i.pravatar.cc/40?img=3' },
];

const OrdersContainers = () => {
  const { t } = useTranslation(); // Initialize translation hook
  const [showCalendar, setShowCalendar] = useState(false);
  const { userProfile } = useDashboard()
  const [selectedDates, setSelectedDates] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedRegions1, setSelectedRegions1] = useState([]);
  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);
  const calendarRef = useRef(null);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  const buttonRef3 = useRef(null);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Dispatch Reports");
  const [showModal2, setShowModal2] = useState(false);
  const [search, setSearch] = useState('');
  const [showDropdowns, setShowDropdowns] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [containerMovementData, setContainerMovementData] = useState([]);
  const [dispatchReportData, setDispatchReportData] = useState([]);
  const [driverReportData, setDriverReportData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [truckInspectionData, setTruckInspectionData] = useState([]);
  const [trackingData, setTrackingData] = useState(null);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [shippingLines, setShippingLines] = useState([]);
  const [error, setError] = useState(null);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const [showTrackFormModal, setShowTrackFormModal] = useState(false);
  const [formData, setFormData] = useState({
    containerNumber: '',
    shippingLine: '',
    emailAddress: '',
    referenceNo: '',
    companyType: 'Dispax',
  });
  const [formError, setFormError] = useState('');

  const filteredDrivers = drivers.filter(driver =>
    driver.name.toLowerCase().includes(search.toLowerCase())
  );

  const regions = ["Bank Transfer", "Credit Card", "Cash", "UPI"];
  const regions2 = ["Delivered", "In-transit", "Delayed"];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRef2.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(e.target) &&
        !buttonRef3.current.contains(e.target)
      ) {
        setShowDropdown2(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarToggle = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setCalendarPosition({
        top: rect.height + 5,
        left: 0,
      });
    }
    setShowCalendar((prev) => !prev);
  };

  const toggleRegion = (region) => {
    setSelectedRegions(prev =>
      prev.includes(region)
        ? prev.filter(r => r !== region)
        : [...prev, region]
    );
  };

  const toggleRegion2 = (region1) => {
    setSelectedRegions1(prev =>
      prev.includes(region1)
        ? prev.filter(r => r !== region1)
        : [...prev, region1]
    );
  };

  // Calculate working hours from punchIn and punchOut
  const calculateWorkingHours = (punchIn, punchOut) => {
    if (!punchIn || !punchOut) return 0;
    const punchInTime = new Date(`2025-08-19T${punchIn}`);
    const punchOutTime = new Date(`2025-08-19T${punchOut}`);
    if (isNaN(punchInTime) || isNaN(punchOutTime)) return 0;
    const diffMs = punchOutTime - punchInTime;
    return (diffMs / (1000 * 60 * 60)).toFixed(2); // Convert to hours
  };

  // Placeholder for fetching truck inspection reports (replace with actual API when available)
  const fetchTruckInspectionReports = async () => {
    try {
      // Mock data for truck inspections (replace with actual API call)
      const mockInspections = [
        {
          driverId: "683d4d1fffa3676395bfa0a2",
          vehicleNumber: "UP14 BK 7821",
          inspectionDate: "2025-08-19",
          status: "Pass",
          notes: t('ordersContainers.truckInspectionNotes'),
        },
      ];
      setTruckInspectionData(mockInspections);
      // Send to dispatcher (mock implementation)
      console.log(t('ordersContainers.truckInspectionSent'), mockInspections);
    } catch (error) {
      console.error('Failed to fetch truck inspection reports:', error);
      setError(t('errors.fetchTruckInspectionsFailed'));
    }
  };
  console.log('dispatchReportData')
  // Generate PDF with enhanced data
  // MODIFIED PDF Generation function
  const generatePDF = async () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text(t('ordersContainers.reportsTitle'), 14, 22);

    if (selectedTab === "Dispatch Reports") {
      // --- SECTION 1: ORIGINAL DISPATCH REPORTS TABLE (UNCHANGED) ---
      doc.text(t('ordersContainers.dispatchReports'), 14, 30);
      const dispatchColumns = [
        { header: t('ordersContainers.date'), dataKey: 'date' },
        { header: t('ordersContainers.totalDispatches'), dataKey: 'totalDispatched' },
        { header: t('ordersContainers.completed'), dataKey: 'totalDelivered' },
        { header: t('ordersContainers.delayed'), dataKey: 'totalDelayed' },
        { header: t('ordersContainers.cancelled'), dataKey: 'totalCancelled' },
      ];
      const dispatchData = dispatchReportData.map(row => ({
        date: row.date,
        totalDispatched: row.totalDispatched,
        totalDelivered: row.totalDelivered,
        totalDelayed: row.totalDelayed,
        totalCancelled: row.totalCancelled,
      }));
      autoTable(doc, {
        columns: dispatchColumns,
        body: dispatchData,
        startY: 40,
        theme: 'grid',
        headStyles: { fillColor: [111, 26, 255], textColor: [255, 255, 255] },
        styles: { textColor: [0, 0, 0], fontSize: 10 },
      });

      // --- SECTION 2: NEW DRIVER SUMMARY TABLE (ADDED) ---
      doc.text(t('ordersContainers.driverSummaryReport', 'Driver Summary Report'), 14, doc.lastAutoTable.finalY + 15);

      // Fetch driver attendance data for the selected period
      let driverHoursData = [];
      try {
        const params = {
          fromDate: selectedDates.length > 0 ? format(selectedDates[0], "yyyy-MM-dd") : format(startOfWeek(new Date()), "yyyy-MM-dd"),
          toDate: selectedDates.length > 1 ? format(selectedDates[selectedDates.length - 1], "yyyy-MM-dd") : format(endOfWeek(new Date()), "yyyy-MM-dd"),
        };
        const attendance = await getAllAttendance(params);
        driverHoursData = attendance.docs || [];
      } catch (error) {
        console.error('Failed to fetch attendance data for PDF:', error);
        // alert('Could not fetch driver hours data for the report.');
      }

      // Aggregate data by driver
      const driverReportMap = new Map();
      dispatchReportData.forEach(report => {
        const driverId = report.userId?._id;
        if (!driverId) return;

        if (!driverReportMap.has(driverId)) {
          driverReportMap.set(driverId, {
            driverName: report.userId.fullName || t('dashboard.na'),
            totalLoads: 0,
            totalHours: 0,
            logs: []
          });
        }
        const driverData = driverReportMap.get(driverId);
        driverData.totalLoads += (report.totalDelivered || 0);
      });

      driverHoursData.forEach(att => {
        const driverId = att.userId?._id;
        if (!driverId) return;
        if (driverReportMap.has(driverId)) {
          const driverData = driverReportMap.get(driverId);
          const dailyHours = parseFloat(calculateWorkingHours(att.punchIn, att.punchOut) || 0);
          driverData.totalHours += dailyHours;
          driverData.logs.push(`${att.date}: ${att.punchIn || 'N/A'} - ${att.punchOut || 'N/A'} (${dailyHours.toFixed(2)} hrs)`);
        }
      });

      const driverReportBody = Array.from(driverReportMap.values()).map(data => ({
        driverName: data.driverName,
        totalLoads: data.totalLoads,
        totalHours: data.totalHours.toFixed(2),
        logs: data.logs.join('\n')
      }));

      const driverReportColumns = [
        { header: t('ordersContainers.driverName', 'Driver Name'), dataKey: 'driverName' },
        { header: t('ordersContainers.totalLoadsMoved', 'Total Loads Moved'), dataKey: 'totalLoads' },
        { header: t('ordersContainers.totalHoursWorked', 'Total Hours Worked'), dataKey: 'totalHours' },
        { header: t('ordersContainers.driverLogs', 'Driver Logs'), dataKey: 'logs' },
      ];

      autoTable(doc, {
        columns: driverReportColumns,
        body: driverReportBody,
        startY: doc.lastAutoTable.finalY + 20, // Position below the new title
        theme: 'grid',
        headStyles: { fillColor: [111, 26, 255], textColor: [255, 255, 255] },
        styles: { textColor: [0, 0, 0], fontSize: 8, cellPadding: 2 },
        didParseCell: (data) => {
          if (data.column.dataKey === 'logs') {
            data.cell.styles.fontSize = 7;
          }
        }
      });

      // --- SECTION 3: INVOICE TOTALS (POSITIONED AFTER BOTH TABLES) ---
      const totalCompletedInvoices = invoiceData
        .filter(invoice => invoice.status === 'Completed')
        .reduce((sum, invoice) => sum + (parseFloat(invoice.amount) || 0), 0);
      doc.text(`Total Completed Invoices Amount: $${totalCompletedInvoices.toFixed(2)}`, 14, doc.lastAutoTable.finalY + 10);

    } else if (selectedTab === "Driver Reports") {
      // --- DRIVER REPORTS TAB LOGIC (UNCHANGED) ---
      // Driver Reports Table
      doc.text(t('ordersContainers.driverReports'), 14, 30);
      const driverColumns = [
        { header: t('ordersContainers.driverName'), dataKey: 'driverName' },
        { header: t('ordersContainers.date'), dataKey: 'date' },
        { header: t('ordersContainers.hoursWorked'), dataKey: 'hoursWorked' },
        { header: t('ordersContainers.loadsCompleted'), dataKey: 'loadsCompleted' },
      ];
      const driverData = driverReportData.map(row => ({
        driverName: row.userId.fullName,
        date: row.date,
        hoursWorked: row.hoursWorked,
        loadsCompleted: row.loadsCompleted,
      }));
      autoTable(doc, {
        columns: driverColumns,
        body: driverData,
        startY: 40,
        theme: 'grid',
        headStyles: { fillColor: [111, 26, 255], textColor: [255, 255, 255] },
        styles: { textColor: [0, 0, 0], fontSize: 10 },
      });

      // Truck Inspection Reports
      doc.text(t('ordersContainers.truckInspectionReports'), 14, doc.lastAutoTable.finalY + 10);
      const inspectionColumns = [
        { header: t('ordersContainers.driverId'), dataKey: 'driverId' },
        { header: t('ordersContainers.vehicleNumber'), dataKey: 'vehicleNumber' },
        { header: t('ordersContainers.inspectionDate'), dataKey: 'inspectionDate' },
        { header: t('ordersContainers.status'), dataKey: 'status' },
        { header: t('ordersContainers.notes'), dataKey: 'notes' },
      ];
      const inspectionData = truckInspectionData.map(row => ({
        driverId: row.driverId,
        vehicleNumber: row.vehicleNumber,
        inspectionDate: row.inspectionDate,
        status: t(`ordersContainers.status.${row.status.toLowerCase()}`, { defaultValue: row.status }),
        notes: row.notes,
      }));
      autoTable(doc, {
        columns: inspectionColumns,
        body: inspectionData,
        startY: doc.lastAutoTable.finalY + 20,
        theme: 'grid',
        headStyles: { fillColor: [111, 26, 255], textColor: [255, 255, 255] },
        styles: { textColor: [0, 0, 0], fontSize: 10 },
      });
    }

    doc.save(`${t('ordersContainers.reportsTitle')}_${format(new Date(), 'yyyy-MM-dd')}.pdf`);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch dispatch report data and invoice data for "Dispatch Reports" tab
  useEffect(() => {
    if (selectedTab === "Dispatch Reports") {
      const fetchDispatchReports = async () => {
        try {
          const params = {
            fromDate: selectedDates.length > 0 ? format(selectedDates[0], "yyyy-MM-dd") : format(startOfWeek(new Date()), "yyyy-MM-dd"),
            toDate: selectedDates.length > 1 ? format(selectedDates[selectedDates.length - 1], "yyyy-MM-dd") : format(endOfWeek(new Date()), "yyyy-MM-dd"),
            status: selectedRegions1.join(',') || '',
          };
          const reports = await getAllDispatchReport(params);
          setDispatchReportData(reports.docs || []);

          // Fetch invoice data for the same date range
          const invoiceParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            status: 'Completed',
          };
          const invoices = await getAllInvoices(invoiceParams);
          setInvoiceData(invoices.docs || []);
        } catch (error) {
          console.error('Failed to fetch dispatch reports or invoices:', error);
          setError(t('errors.fetchDispatchReportsFailed'));
        }
      };
      fetchDispatchReports();
    }
  }, [selectedTab, selectedDates, selectedRegions1, t]);

  // Fetch container data for "Container Movement History" tab
  useEffect(() => {
    if (selectedTab === "Container Movement History") {
      const fetchContainerData = async () => {
        try {
          const shipments = await getAllShipment();
          let shipmentData = shipments.docs || [];

          let filteredClients = shipmentData;

          // 3. Conditional Filtering Logic
          if (userProfile?.aiPackageId) {
            // If AI Package exists -> Show ALL (No Filter)
            filteredClients = shipmentData;
          } else {
            // Else -> Filter by 'Dispax'
            filteredClients = shipmentData.filter(client => client?.companyType === 'Dispax');
          }


          const containerPromises = filteredClients.map(async (shipment) => {
            try {
              const containerInfo = await getContainerInfo(shipment.containerNumber);
              return {
                ...shipment,
                containerInfo: containerInfo[0] || {},
              };
            } catch (error) {
              console.error(`Failed to fetch container info for ${shipment.containerNumber}:`, error);
              return { ...shipment, containerInfo: {} };
            }
          });

          const updatedData = await Promise.all(containerPromises);
          setContainerMovementData(updatedData);
        } catch (error) {
          console.error('Failed to fetch shipments:', error);
          setError(t('errors.fetchContainerDataFailed'));
        }
      };
      fetchContainerData();
    }
  }, [selectedTab, t]);

  // Fetch driver attendance and shipment data for "Driver Reports" tab
  useEffect(() => {
    if (selectedTab === "Driver Reports") {
      const fetchDriverReports = async () => {
        try {
          const params = {
            fromDate: selectedDates.length > 0 ? format(selectedDates[0], "yyyy-MM-dd") : format(startOfWeek(new Date()), "yyyy-MM-dd"),
            toDate: selectedDates.length > 1 ? format(selectedDates[selectedDates.length - 1], "yyyy-MM-dd") : format(endOfWeek(new Date()), "yyyy-MM-dd"),
          };




          const attendance = await getAllAttendance(params);


          let allClients = attendance.docs || [];

          let filteredClients = allClients;

          // 3. Conditional Filtering Logic
          if (userProfile?.aiPackageId) {
            // If AI Package exists -> Show ALL (No Filter)
            filteredClients = allClients;
          } else {
            // Else -> Filter by 'Dispax'
            filteredClients = allClients.filter(client => client?.companyType === 'Dispax');
          }





          const shipments = await getAllShipment({ status: 'Completed' });




                 let shipmentsDatas = shipments.docs || [];

          let shipmentsData = shipmentsDatas;

          // 3. Conditional Filtering Logic
          if (userProfile?.aiPackageId) {
            // If AI Package exists -> Show ALL (No Filter)
            filteredClients = allClients;
          } else {
            // Else -> Filter by 'Dispax'
            filteredClients = allClients.filter(client => client?.companyType === 'Dispax');
          }



          // Aggregate data by driver
          const driverData = attendance.docs.map(record => {
            const completedShipments = shipmentsData.docs.filter(shipment => shipment.driverId === record.userId._id && shipment.status === 'Completed').length;
            return {
              ...record,
              hoursWorked: calculateWorkingHours(record.punchIn, record.punchOut),
              loadsCompleted: completedShipments,
            };
          });
          setDriverReportData(driverData);

          // Fetch truck inspection reports
          await fetchTruckInspectionReports();
        } catch (error) {
          console.error('Failed to fetch driver reports:', error);
          setError(t('errors.fetchDriverReportsFailed'));
        }
      };
      fetchDriverReports();
    }
  }, [selectedTab, selectedDates, t]);

  // Fetch shipping lines for dropdown
  useEffect(() => {
    const fetchShippingLines = async () => {
      try {
        const lines = await getShippingLineList();
        setShippingLines(Array.isArray(lines) ? lines : []);
      } catch (error) {
        console.error('Failed to fetch shipping lines:', error);
        setError(t('errors.fetchShippingLinesFailed'));
      }
    };
    fetchShippingLines();
  }, [t]);

  // Validate container number format
  const isValidContainerNumber = (containerNumber) => {
    const regex = /^[A-Z]{4}\d{7}$/;
    return regex.test(containerNumber);
  };

  // Handle form input changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormError('');
  };

  // Handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!isValidContainerNumber(formData.containerNumber)) {
      setFormError(t('errors.invalidContainerNumber'));
      return;
    }
    if (!formData.shippingLine) {
      setFormError(t('errors.selectShippingLine'));
      return;
    }
    if (!formData.emailAddress) {
      setFormError(t('errors.enterEmailAddress'));
      return;
    }
    if (!formData.referenceNo) {
      setFormError(t('errors.enterReferenceNumber'));
      return;
    }
    try {
      const result = await postCustomContainerForm(formData);
      console.log(t('ordersContainers.apiResponse'), result);
      setTrackingData(result.data);
      setShowTrackFormModal(false);
      setShowTrackingModal(true);
      setFormData({
        containerNumber: '',
        shippingLine: '',
        emailAddress: '',
        referenceNo: '',
      });
    } catch (error) {
      console.error('Failed to fetch tracking data:', error);
      setFormError(t('errors.fetchTrackingDataFailed', { message: error.message }));
    }
  };

  // Open form modal instead of direct API call
  const handleView = (row) => {
    setFormData({
      containerNumber: row.containerNumber || '',
      shippingLine: '',
      emailAddress: 'user@example.com',
      referenceNo: 'y3756fhsfdh',
    });
    setShowTrackFormModal(true);
  };

  // Calculate map center
  const getMapCenter = (trackingData) => {
    const current = trackingData?.currentLocation?.coordinates;
    const destination = trackingData?.destinationLocation?.coordinates;
    if (current && destination && current.length === 2 && destination.length === 2) {
      return [
        (current[1] + destination[1]) / 2,
        (current[0] + destination[0]) / 2,
      ];
    }
    return [34.0522, -118.2437]; // Default to Los Angeles
  };

  // Validate coordinates
  const hasValidCoordinates = (trackingData) => {
    const current = trackingData?.currentLocation?.coordinates;
    const destination = trackingData?.destinationLocation?.coordinates;
    return (
      current &&
      destination &&
      Array.isArray(current) &&
      Array.isArray(destination) &&
      current.length === 2 &&
      destination.length === 2 &&
      current.every(num => typeof num === 'number' && isFinite(num)) &&
      destination.every(num => typeof num === 'number' && isFinite(num))
    );
  };

  return (
    <div className="text-white relative px-2 md:px-0">
      {/* {error && (
        <div className="bg-red-500 text-white p-4 mb-4 rounded">
          {error}
        </div>
      )} */}
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
        <h1 className="text-2xl font-semibold">{t('ordersContainers.title')}</h1>
        {/* <div className="flex flex-col md:flex-row items-center bg-[#10194E] rounded-xl shadow-md w-full md:w-auto">
          <div className="flex items-center gap-2 px-4 py-5 border-b md:border-b-0 md:border-r border-[#1E2A60] text-white w-full md:w-auto">
            <FiFilter className="text-lg" />
            <span className="text-sm">{t('orders.filterBy')}</span>
          </div>
          <div className="relative w-full md:w-auto">
            <button
              ref={buttonRef}
              onClick={handleCalendarToggle}
              className="px-4 py-5 text-sm text-white border-b md:border-b-0 md:border-r border-[#1E2A60] bg-transparent w-full md:w-auto text-left md:text-center"
            >
              {selectedDates.length > 0
                ? selectedDates.map((date) => format(date, "PP")).join(", ")
                : t('orders.date')}
            </button>
            {showCalendar && (
              <div
                ref={calendarRef}
                className="absolute left-0 md:left-9 md:-translate-x-24 p-4 shadow-lg rounded z-50 w-[90%] md:w-auto"
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                  top: calendarPosition.top,
                  left: calendarPosition.left,
                }}
              >
                <DayPicker
                  mode="multiple"
                  selected={selectedDates}
                  onSelect={setSelectedDates}
                  footer={
                    <div className="pt-4">
                      <div className="flex justify-start">
                        <span className="text-sm text-gray-400">{t('orders.multipleDates')}</span>
                      </div>
                      <div className="flex justify-center mt-2">
                        <button
                          onClick={() => setShowCalendar(false)}
                          className="bg-[#6F1AFF] text-white px-4 py-1 rounded text-sm"
                        >
                          {t('orders.apply')}
                        </button>
                      </div>
                    </div>
                  }
                />
              </div>
            )}
          </div>
          <div className="relative w-full md:w-auto">
            <button
              ref={buttonRef2}
              onClick={() => setShowDropdown(!showDropdown)}
              className="bg-transparent text-white px-4 py-5 text-sm border-b md:border-b-0 md:border-r border-[#1E2A60] outline-none w-full md:w-auto text-left md:text-center"
            >
              {selectedRegions.length > 0 ? selectedRegions.join(', ') : t('orders.paymentMethod')}
            </button>
            {showDropdown && (
              <div
                ref={dropdownRef}
                className="absolute left-0 md:right-0 top-full mt-2 w-[90%] md:w-80 text-white rounded-2xl p-6 z-10 shadow-lg"
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
              >
                <h2 className="text-lg font-semibold mb-4">{t('orders.paymentMethod')}</h2>
                <div className="grid grid-cols-3 gap-3 mb-4">
                  {regions.map((region) => (
                    <button
                      key={region}
                      onClick={() => toggleRegion(region)}
                      className={`px-3 py-2 rounded-full border transition-all text-sm ${
                        selectedRegions.includes(region)
                          ? "bg-white text-black font-semibold"
                          : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                      }`}
                    >
                      {t(`ordersContainers.paymentMethods.${region.toLowerCase().replace(' ', '_')}`, { defaultValue: region })}
                    </button>
                  ))}
                </div>
                <p className="text-sm text-gray-300 mb-3">{t('orders.multiplePaymentMethods')}</p>
                <div className="text-center">
                  <button
                    onClick={() => setShowDropdown(false)}
                    className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90 text-sm"
                  >
                    {t('orders.applyNow')}
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="relative w-full md:w-auto">
            <button
              ref={buttonRef3}
              onClick={() => setShowDropdown2(!showDropdown2)}
              className="bg-transparent text-white px-4 py-5 text-sm border-b md:border-b-0 md:border-r border-[#1E2A60] outline-none w-full md:w-auto text-left md:text-center"
            >
              {selectedRegions1.length > 0 ? selectedRegions1.join(', ') : t('orders.statusLabel')}
            </button>
            {showDropdown2 && (
              <div
                ref={dropdownRef2}
                className="absolute left-0 md:right-0 top-full mt-2 w-[90%] md:w-80 text-white rounded-2xl p-6 z-10 shadow-lg"
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
              >
                <h2 className="text-lg font-semibold mb-4">{t('orders.selectOrderStatus')}</h2>
                <div className="grid grid-cols-3 gap-3 mb-4">
                  {regions2.map((region1) => (
                    <button
                      key={region1}
                      onClick={() => toggleRegion2(region1)}
                      className={`px-3 py-2 rounded-full border transition-all text-sm ${
                        selectedRegions1.includes(region1)
                          ? "bg-white text-black font-semibold"
                          : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                      }`}
                    >
                      {t(`orders.status.${region1.toLowerCase()}`, { defaultValue: region1 })}
                    </button>
                  ))}
                </div>
                <p className="text-sm text-gray-300 mb-3">{t('orders.multipleOrderStatus')}</p>
                <div className="text-center">
                  <button
                    onClick={() => setShowDropdown2(false)}
                    className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90 text-sm"
                  >
                    {t('orders.applyNow')}
                  </button>
                </div>
              </div>
            )}
          </div>
          <button
            onClick={() => {
              setSelectedDates([]);
              setSelectedRegions([]);
              setSelectedRegions1([]);
            }}
            className="flex items-center gap-1 px-4 py-5 text-sm text-orange-400 hover:underline w-full md:w-auto text-left md:text-center"
          >
            <FiRotateCw className="text-sm" />
            {t('orders.resetFilter')}
          </button>
        </div> */}
      </div>

      {/* Tab Navigation */}
      <div className="mb-6">
        <div className="flex flex-col md:flex-row gap-1 md:gap-4 bg-white p-1 md:pe-2 md:ps-2 md:pt-1 md:pb-1 border rounded-xl">
          <button
            onClick={() => setSelectedTab("Dispatch Reports")}
            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${selectedTab === "Dispatch Reports"
                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                : "bg-white text-[#7E31FF]"
              }`}
          >
            {t('ordersContainers.dispatchReports')}
          </button>
          <button
            onClick={() => setSelectedTab("Container Movement History")}
            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${selectedTab === "Container Movement History"
                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                : "bg-white text-[#7E31FF]"
              }`}
          >
            {t('ordersContainers.containerMovementHistory')}
          </button>
          {/* <button
            onClick={() => setSelectedTab("Driver Reports")}
            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${
              selectedTab === "Driver Reports"
                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                : "bg-white text-[#7E31FF]"
            }`}
          >
            {t('ordersContainers.driverReports')}
          </button> */}
        </div>
      </div>

      {selectedTab === "Dispatch Reports" && (
        <div className="flex flex-col md:flex-row items-start md:items-end justify-end mb-6 gap-4">
          <button
            onClick={generatePDF}
            className="w-full md:w-auto md:ml-4 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] hover:opacity-90 px-5 py-3 md:py-2 rounded-xl text-white font-medium flex items-center justify-center gap-2 shadow-md"
            aria-label={t('ordersContainers.generateReport')}
          >
            <FiPlus className="text-md" />
            {t('ordersContainers.generateReport')}
          </button>
        </div>
      )}

      {showTrackFormModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 md:p-0">
          <div
            className="rounded-xl shadow-xl text-white p-4 md:p-6 relative w-full md:w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{
              background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
            }}
          >
            <button
              onClick={() => setShowTrackFormModal(false)}
              className="absolute top-2 right-4 text-2xl font-bold"
              aria-label={t('alt.closeTrackFormModal')}
            >
              ×
            </button>
            <h2 className="text-xl font-bold mb-4">{t('ordersContainers.trackContainer')}</h2>
            {formError && (
              <div className="bg-red-500 text-white p-2 mb-4 rounded">
                {formError}
              </div>
            )}
            <form className="space-y-4" onSubmit={handleFormSubmit}>
              <div>
                <label className="text-sm block mb-1">{t('orders.containerId')}</label>
                <input
                  type="text"
                  name="containerNumber"
                  value={formData.containerNumber}
                  onChange={handleFormChange}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  placeholder={t('ordersContainers.containerNumberPlaceholder')}
                  required
                  aria-label={t('orders.containerId')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('ordersContainers.shippingLine')}</label>
                <select
                  name="shippingLine"
                  value={formData.shippingLine}
                  onChange={handleFormChange}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  required
                  aria-label={t('ordersContainers.shippingLine')}
                >
                  <option value="">{t('ordersContainers.selectShippingLine')}</option>
                  {shippingLines.map((line, idx) => (
                    <option key={idx} value={line}>{line}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-sm block mb-1">{t('ordersContainers.emailAddress')}</label>
                <input
                  type="email"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleFormChange}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  placeholder={t('ordersContainers.emailPlaceholder')}
                  required
                  aria-label={t('ordersContainers.emailAddress')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('ordersContainers.referenceNumber')}</label>
                <input
                  type="text"
                  name="referenceNo"
                  value={formData.referenceNo}
                  onChange={handleFormChange}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  placeholder={t('ordersContainers.referenceNumberPlaceholder')}
                  required
                  aria-label={t('ordersContainers.referenceNumber')}
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#6F1AFF] text-white py-3 rounded-md font-semibold hover:opacity-90"
                aria-label={t('ordersContainers.saveAndTrack')}
              >
                {t('ordersContainers.saveAndTrack')}
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
        <div className="min-w-[800px] md:min-w-0">
          {selectedTab === "Dispatch Reports" && (
            <table className="w-full table-auto text-sm text-left">
              <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                <tr>
                  <th className="p-4">
                    <input type="checkbox" aria-label={t('alt.selectAll')} />
                  </th>
                  <th className="p-4">{t('ordersContainers.date')}</th>
                  <th className="p-4">{t('ordersContainers.totalDispatches')}</th>
                  <th className="p-4">{t('ordersContainers.completed')}</th>
                  <th className="p-4">{t('ordersContainers.delayed')}</th>
                  <th className="p-4">{t('ordersContainers.cancelled')}</th>
                  <th className="p-4">{t('ordersContainers.totalInvoiceAmount')}</th>
                </tr>
              </thead>
              <tbody>
                {dispatchReportData.length === 0 && (
                  <tr>
                    <td colSpan="7" className="p-4 text-center">{t('ordersContainers.noData')}</td>
                  </tr>
                )}
                {dispatchReportData.map((row, idx) => (
                  <tr key={idx} className="border-t border-[#2A2A4D]">
                    <td className="p-4">
                      <input type="checkbox" aria-label={t('alt.selectRow', { index: idx + 1 })} />
                    </td>
                    <td className="p-4">{row.date || t('dashboard.na')}</td>
                    <td className="p-4">{row.totalDispatched || 0}</td>
                    <td className="p-4">{row.totalDelivered || 0}</td>
                    <td className="p-4">{row.totalDelayed || 0}</td>
                    <td className="p-4">{row.totalCancelled || 0}</td>
                    <td className="p-4">
                      ${invoiceData
                        .filter(invoice => invoice.status === 'Completed' && invoice.date === row.date)
                        .reduce((sum, invoice) => sum + (parseFloat(invoice.amount) || 0), 0)
                        .toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {selectedTab === "Container Movement History" && (
            <table className="w-full table-auto text-sm text-left">
              <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                <tr>
                  <th className="p-4">
                    <input type="checkbox" aria-label={t('alt.selectAll')} />
                  </th>
                  <th className="p-4">{t('orders.containerId')}</th>
                  <th className="p-4">{t('dashboard.driver')}</th>
                  <th className="p-4">{t('orders.statusLabel')}</th>
                  <th className="p-4">{t('ordersContainers.lastKnownLocation')}</th>
                  <th className="p-4">{t('ordersContainers.lastUpdate')}</th>
                  <th className="p-4">{t('ordersContainers.eta')}</th>
                  <th className="p-4">{t('ordersContainers.action')}</th>
                </tr>
              </thead>
              <tbody>
                {containerMovementData.length === 0 && (
                  <tr>
                    <td colSpan="8" className="p-4 text-center">{t('ordersContainers.noData')}</td>
                  </tr>
                )}
                {containerMovementData.map((row, idx) => (
                  <tr key={idx} className="border-t border-[#2A2A4D]">
                    <td className="p-4">
                      <input type="checkbox" aria-label={t('alt.selectRow', { index: idx + 1 })} />
                    </td>
                    <td className="p-4">{row.containerNumber || t('dashboard.na')}</td>
                    <td className="p-4">{row.movement || t('dashboard.na')}</td>
                    <td className="p-4">
                      <span className={`${statusColors[row.status] || 'bg-gray-500'} text-white px-2 py-1 rounded`}>
                        {t(`orders.status.${row.status.toLowerCase()}`, { defaultValue: row.status })}
                      </span>
                    </td>
                    <td className="p-4">
                      {row.currentLocation?.coordinates?.join(', ') || t('dashboard.na')}
                    </td>
                    <td className="p-4">{row.updatedAt ? new Date(row.updatedAt).toLocaleDateString() : t('dashboard.na')}</td>
                    <td className="p-4">{row.eta || t('dashboard.na')}</td>
                    <td className="p-4">
                      <button
                        onClick={() => handleView(row)}
                        className="bg-blue-500 text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                        aria-label={t('alt.viewContainer', { id: row.containerNumber || 'unknown' })}
                      >
                        {t('ordersContainers.view')}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {selectedTab === "Driver Reports" && (
            <table className="w-full table-auto text-sm text-left">
              <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                <tr>
                  <th className="p-4">
                    <input type="checkbox" aria-label={t('alt.selectAll')} />
                  </th>
                  <th className="p-4">{t('ordersContainers.driverName')}</th>
                  <th className="p-4">{t('ordersContainers.date')}</th>
                  <th className="p-4">{t('ordersContainers.hoursWorked')}</th>
                  <th className="p-4">{t('ordersContainers.loadsCompleted')}</th>
                </tr>
              </thead>
              <tbody>
                {driverReportData.length === 0 && (
                  <tr>
                    <td colSpan="5" className="p-4 text-center">{t('ordersContainers.noData')}</td>
                  </tr>
                )}
                {driverReportData.map((row, idx) => (
                  <tr key={idx} className="border-t border-[#2A2A4D]">
                    <td className="p-4">
                      <input type="checkbox" aria-label={t('alt.selectRow', { index: idx + 1 })} />
                    </td>
                    <td className="p-4">{row.userId.fullName || t('dashboard.na')}</td>
                    <td className="p-4">{row.date || t('dashboard.na')}</td>
                    <td className="p-4">{row.hoursWorked ? `${row.hoursWorked} ${t('ordersContainers.hours')}` : t('dashboard.na')}</td>
                    <td className="p-4">{row.loadsCompleted || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="text-sm text-gray-400 p-4">
          {t('ordersContainers.showing', {
            start: 1,
            end:
              selectedTab === "Dispatch Reports"
                ? dispatchReportData.length
                : selectedTab === "Container Movement History"
                  ? containerMovementData.length
                  : driverReportData.length,
            total:
              selectedTab === "Dispatch Reports"
                ? dispatchReportData.length
                : selectedTab === "Container Movement History"
                  ? containerMovementData.length
                  : driverReportData.length,
          })}
        </div>
      </div>

      {showTrackingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 md:p-0">
          <div
            className="rounded-xl shadow-xl text-white p-4 md:p-6 relative w-full md:w-[90%] max-w-[600px] max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{
              background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
            }}
          >
            <button
              onClick={() => setShowTrackingModal(false)}
              className="absolute top-2 right-4 text-2xl font-bold"
              aria-label={t('alt.closeTrackingModal')}
            >
              ×
            </button>
            <h2 className="text-xl font-bold mb-4">{t('ordersContainers.containerTrackingDetails')}</h2>
            {trackingData ? (
              <>
                <p className="mb-2">{t('orders.containerId')}: {trackingData.containerNumber || t('dashboard.na')}</p>
                <p className="mb-2">{t('orders.statusLabel')}: {t(`orders.status.${trackingData.status.toLowerCase()}`, { defaultValue: trackingData.status || t('dashboard.na') })}</p>
                <p className="mb-2">{t('ordersContainers.currentLocation')}: {trackingData.currentLocation?.coordinates?.join(', ') || t('dashboard.na')}</p>
                <p className="mb-2">{t('ordersContainers.destination')}: {trackingData.destinationLocation?.coordinates?.join(', ') || t('dashboard.na')}</p>
                <p className="mb-2">{t('ordersContainers.origin')}: {trackingData.origin || t('dashboard.na')}</p>
                <p className="mb-2">{t('orders.destination')}: {trackingData.destination || t('dashboard.na')}</p>
                <p className="mb-2">{t('ordersContainers.estimatedDelivery')}: {trackingData.extimateDeliveryDate || t('dashboard.na')}</p>
                {hasValidCoordinates(trackingData) ? (
                  <div className="mb-4" style={{ height: '400px' }}>
                    <MapContainer
                      center={getMapCenter(trackingData)}
                      zoom={4}
                      style={{ height: '100%', width: '100%' }}
                    >
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution={t('ordersContainers.mapAttribution')}
                      />
                      <Marker position={[trackingData.currentLocation.coordinates[1], trackingData.currentLocation.coordinates[0]]}>
                        <Popup>{t('ordersContainers.currentLocation')}: {trackingData.origin || t('dashboard.na')}</Popup>
                      </Marker>
                      <Marker position={[trackingData.destinationLocation.coordinates[1], trackingData.destinationLocation.coordinates[0]]}>
                        <Popup>{t('ordersContainers.destination')}: {trackingData.destination || t('dashboard.na')}</Popup>
                      </Marker>
                      <Polyline
                        positions={[
                          [trackingData.currentLocation.coordinates[1], trackingData.currentLocation.coordinates[0]],
                          [trackingData.destinationLocation.coordinates[1], trackingData.destinationLocation.coordinates[0]],
                        ]}
                        color="blue"
                      />
                    </MapContainer>
                  </div>
                ) : (
                  <div className="bg-red-500 text-white p-2 mb-4 rounded">
                    {t('errors.invalidCoordinates')}
                  </div>
                )}
              </>
            ) : (
              <div className="bg-red-500 text-white p-2 mb-4 rounded">
                {t('ordersContainers.noTrackingData')}
              </div>
            )}
            {console.log(t('ordersContainers.trackingDataLog'), trackingData)}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersContainers;
